import styled from 'styled-components';
import TextInput, { LinkableTextInput } from 'components/ui/TextInput';
import { CurrencyInput } from 'components/ui/Inputs';
import Select from 'components/ui/Select';
import { Row } from 'components/shared/Layout';

import { colours } from 'themes/default';

export const FormContainer = styled.div`
  background: ${colours.Greyscale.MistGrey};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  margin-bottom: 20px;
  padding: 20px;
`;

export const StyledLabel = styled.label`
  display: block;
  padding-bottom: 8px;
`;

export const StyledPriceWrapper = styled.div`
  margin-left: -15px;
`;

export const StyledPriceLabel = styled(StyledLabel)`
  padding-left: 16px;
`;

export const StyledCurrencyInput = styled(CurrencyInput)`
  display: flex;
  align-items: center;
  font-size: 16px;
  input {
    font-size: 16px;
    border-radius: 5px;
    background-color: ${colours.Greyscale.White};
    color: ${colours.Shades.BlueShade40};
    border: 1px solid ${colours.Greyscale.SilverGrey};
    padding: 0.6em 1.4em 0.5em 0.8em;
    margin-left: 6px;
    width: 70px;
    &:read-only {
      background: ${colours.Greyscale.MistGrey};
    }
  }
`;
export const StyledTextInput = styled(TextInput)`
  width: 90%;
  box-sizing: border-box;
  &:read-only {
    background: ${colours.Greyscale.MistGrey};
  }
`;

export const StyledSelect = styled(Select)`
  width: 90%;
  box-sizing: border-box;
  border-radius: 5px;
`;

export const StyledLinkableTextInput = styled(LinkableTextInput)`
  width: 90%;
  box-sizing: border-box;
  &:read-only {
    background: ${colours.Greyscale.MistGrey};
  }
`;

export const StyledDateInput = styled(StyledTextInput)`
  width: 100%;
  ${({ hide }) => hide && 'display: none;'}
`;

export const DatesWrapper = styled.div`
  display: flex;
  width: 90%;
`;

export const DateItem = styled.div`
  flex: 1;
`;

export const DateSeparator = styled.div`
  flex: 0 0 20px;
  align-self: flex-end;
  text-align: center;
  padding: 0.6em 0 0.5em 0;
`;

export const StyledRow = styled(Row)`
  margin-top: 25px;
`;

export const StyledDatesRow = styled(StyledRow)`
  padding-bottom: 34px;
  border-bottom: 1px solid ${colours.Greyscale.SilverGrey};
`;

export const StyledCreatedInfoRow = styled(Row)`
  padding-top: 14px;
`;

export const StyledH2 = styled.h2`
  font-weight: normal;
  font-size: 20px;
  padding-top: ${(props) => props.paddingTop || 0};
`;

export const ErrorMessage = styled.span`
  font-size: 14px;
  color: red;
  display: block;
`;

export const StyledVoucherNotesContainer = styled.div`
  margin: 10px 0 0 0;
  width: inherit;
  background-color: white;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
`;

export const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const OriginalDateIcon = styled.img`
  height: 16px;
  margin-left: 4px;
`;
